export default "__VITE_ASSET__f700ee79__"